/**
 * Public IPs the trading servers send exchange requests from. Users whitelist
 * all of them on their API key. Override per deployment with VITE_SERVER_IPS
 * (comma-separated).
 */
export const SERVER_IPS: string[] = (
  (import.meta.env.VITE_SERVER_IPS as string | undefined) || "185.32.230.16,5.104.87.11,2400:d320:2337:8960::1"
)
  .split(",")
  .map((ip) => ip.trim())
  .filter(Boolean);
